import { getImageUrl } from './getImageUrl'
import { normalizeImageName } from './normalizeImageName'

export const getCuratorImage = (curator: string | 'fallback') => {
  if (curator === 'fallback') return getImageUrl('curators', 'unknownCurator')
  return getImageUrl('curators', normalizeImageName('curators', curator))
}
